module.exports = __webpack_public_path__ + "static/media/concert.eb8e27ff.jpg";